<template>
  <div>
    <v-dialog ref="dialog" persistent v-model="dialog" max-width="800">
      <v-card rounded="lg" class="cdlg">
        <div class="cdlg__head">
          <div class="cdlg__eyebrow">{{ $t("rearrangeStudent.eyebrow") }}</div>
          <div class="cdlg__title">{{ $t("rearrangeStudent.title") }}</div>
          <div class="cdlg__sub">{{ item.name }}</div>
        </div>
        <v-card-text class="cdlg__body">
          <template>
            <v-row v-if="selected === 'other'">
              <v-col v-if="loadingMatch" cols="12">
                <page-skeleton variant="rows" :rows="3" />
              </v-col>
              <v-col
                class="d-flex align-center justify-center flex-column"
                v-else
              >
                <span v-if="currentSlot" class="mb-4">
                  {{
                    $t("rearrangeStudent.currentSlot", {
                      slot: formatCurrentSlot(),
                    })
                  }}
                </span>
                <span v-if="matched.length === 0">
                  {{ $t("rearrangeStudent.noSlots") }}</span
                >
                <div v-else style="height: 100%; width: 100%">
                  <date-picker ref="picker" :horarios="matched" />
                  <p class="cdlg__vote-note">
                    {{ $t("rearrangeStudent.voteNote") }}
                  </p>
                </div>
              </v-col>
            </v-row>
          </template>
        </v-card-text>
        <div class="cdlg__actions">
          <v-btn
            text
            class="cdlg__btn"
            color="var(--dk-ink, #231A2E)"
            @click="close"
          >
            {{ $t("common.cancel") }}
          </v-btn>
          <v-btn
            depressed
            rounded
            dark
            class="cdlg__btn"
            color="#E8276F"
            :disabled="selected === null"
            @click="late"
          >
            <v-icon left size="18">mdi-check</v-icon>
            {{ $t("common.confirm") }}
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import customerApi from "@/shared/pitchCustomerApi";
import { format } from "date-fns";
import {
  formatRearrangeSlot,
  normalizeRearrangeResponse,
} from "@/shared/rearrangeOptions";
export default {
  name: "class-adiar-aluno-dialog",
  props: {
    item: {
      type: Object,
    },
  },
  data: () => {
    return {
      searchLevel: null,
      searchLevelLoading: false,
      loadingMatch: false,
      updateLeasson: false,
      newClassSelectContent: null,
      noContentMessage: false,
      currentSlot: null,
      matched: [],
      selected: null,

      dialog: false,
      postpone: false,
      canceling: false,
      motivo: "",
      englishLevels: [
        {
          text: "Beginner 1",
          value: 0,
        },
        {
          text: "Beginner 2",
          value: 1,
        },
        {
          text: "Essential 1",
          value: 2,
        },
        {
          text: "Essential 2",
          value: 3,
        },
        {
          text: "Pre Intermediate 1",
          value: 4,
        },
        {
          text: "Pre Intermediate 2",
          value: 5,
        },
        {
          text: "Intermediate 1",
          value: 6,
        },
        {
          text: "Intermediate 2",
          value: 7,
        },
        {
          text: "Upper 1",
          value: 8,
        },
        {
          text: "Upper 2",
          value: 9,
        },
        {
          text: "Advanced 1",
          value: 10,
        },
        {
          text: "Advanced 2",
          value: 11,
        },
      ],
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
    };
  },
  methods: {
    open() {
      this.resetRearrangeState();
      this.dialog = true;
      this.$nextTick(() => {
        this.selected = "other";
      });
    },
    close() {
      this.dialog = false;
      this.selected = null;
      this.resetRearrangeState();
    },
    confirm() {
      this.$emit("confirm", this.item);
    },
    formatDate(date) {
      return format(date, this.$t("formats.dateTime"));
    },
    formatCurrentSlot() {
      return formatRearrangeSlot(this.currentSlot);
    },
    resetRearrangeState() {
      this.loadingMatch = false;
      this.currentSlot = null;
      this.matched = [];
    },
    late() {
      const item = Object.assign({}, this.item);
      const picker = this.$refs.picker;
      const pickerData = picker ? picker.getData() : null;

      if (
        this.selected === "other" &&
        (!pickerData?.selectedDate || !pickerData?.selectedHour)
      ) {
        this.$root.$emit("display-alert", {
          text: this.$t("rearrangeStudent.pickDateTime"),
          type: 1,
        });
        return;
      }

      item.data = pickerData;
      this.$emit("confirm", { item, action: this.selected });
    },
  },
  watch: {
    selected: function (value) {
      if (value === "next") {
        this.canceling = true;
        this.updateLeasson = false;
      } else if (value === "cancel") {
        this.updateLeasson = true;
        this.canceling = false;
      } else if (value === "other") {
        this.resetRearrangeState();
        this.loadingMatch = true;

        customerApi
          .rearrange(this.item.id, this.item.classId)
          .then((res) => {
            const options = normalizeRearrangeResponse(res.data);
            this.currentSlot = options.currentSlot;
            this.matched = options.matches;
          })
          .catch(() => {
            this.$root.$emit("display-alert", {
              text: this.$t("rearrangeStudent.loadSlotsFailed"),
              type: 1,
            });
          })
          .finally(() => {
            this.loadingMatch = false;
          });
      } else {
        this.canceling = false;
        this.resetRearrangeState();
      }
    },
  },
};
</script>
<style scoped>
.cdlg {
  --accent: var(--dk-pink, #e8276f);
  border-radius: 20px !important;
  color: var(--dk-ink, #231a2e);
}
.cdlg__head {
  padding: 22px 24px 4px;
}
.cdlg__eyebrow {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--accent);
}
.cdlg__title {
  margin-top: 4px;
  font-size: 1.35rem;
  font-weight: 800;
  line-height: 1.2;
  color: var(--dk-ink, #231a2e);
}
.cdlg__sub {
  margin-top: 6px;
  font-size: 0.88rem;
  color: var(--dk-muted, #6b6472);
  line-height: 1.5;
}
.cdlg__body {
  padding-top: 14px;
  color: var(--dk-ink, #231a2e);
}
.cdlg__actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 10px 20px 18px;
}
.cdlg__btn {
  text-transform: none;
  letter-spacing: normal;
  font-weight: 700;
}
.cdlg__vote-note {
  max-width: 46ch;
  margin: 14px auto 0;
  font-size: 0.84rem;
  line-height: 1.5;
  color: var(--dk-muted, #6b6472);
  text-align: center;
}
</style>
